module.exports = __webpack_public_path__ + "static/datasheet-colorlight-x16-d8d60275d5c29f560f702d8a49071232.pdf";